import generate from './tools/generate'

function home() {
    return {
        groupName: null,
        name: null,
        username: null,
        email: null,
        university: null,
        contact: null,
        password: null,
        passwordConfirmation: null,
        authTab: 0,
        period: null,
        signupStep: 1,
        signupTryoutBackTo: 1,
        credential: null,
        loginPassword: null,
        error: null,
    }
}

const getters = {
    signupData(state) {
        return {
            period_id: state.period.id,
            name: state.name,
            username: state.username,
            email: state.email,
            university: state.university,
            password: state.password,
            password_confirmation: state.passwordConfirmation,
            contact: state.contact
        }
    }
}

export default {
    namespaced: true,
    state: home(),
    getters,
    mutations: generate.mutations(home()),
}
